import { apiFetch } from "../api.js";
import type { HearthUser } from "./types.js";

export function getMe(): Promise<HearthUser> {
  return apiFetch<HearthUser>("/v1/me");
}

/**
 * Bump the caller's `last_seen_at` (presence ping). Returns void on
 * 204. Used by `usePresenceTracker()` — see
 * `web/src/lib/use-presence-tracker.ts`.
 */
export async function pingMeSeen(): Promise<void> {
  await apiFetch<void>("/v1/me/seen", { method: "POST" });
}
